import type { RouteObject } from 'react-router-dom';

/**
 * Public /set-password. OWNED BY `m3-clients` (M3a). Mounted OUTSIDE the signed-in
 * shell by router.tsx: a member without email opens it from their invite link.
 */
export const setPasswordRoutes: RouteObject[] = [
  { path: 'set-password', lazy: async () => ({ Component: (await import('./SetPasswordPage')).SetPasswordPage }) },
];
